
import React, { useState, useEffect } from 'react';
import axios from 'axios'
// var mod1 = require('../../../../src/Baseurl');
import Baseurl from "../../../Baseurl"
import swal from "sweetalert";
import { useHistory } from "react-router-dom";
function AddNewStaff() {
    var history = useHistory();
    const [getData, setGetData] = useState([])
    const [name, setName] = useState("")
    const [phno, setphon] = useState("")
    const [email, setemail] = useState("")
    const [password, setpassword] = useState("")
    const [role, setrole] = useState("")
    function datafromApi(){
        axios.get(`${Baseurl.baseurl}/roles/get-roles`)
        .then(response => {
            setGetData(response.data.details)
        })
        .catch((err) => {
            if(err.toString()==="Error: Network Error")
            {
              history.push('/offline')
            }
            else
            {
              history.push('/400')
            }
        })
    }
    useEffect(() => {
        datafromApi()
    }, [])

    const submitHandler = (e) => {
        e.preventDefault()
        const artical = {
            "Name": name,
            "Email": email,
            "Password": password,
            "Role": role,
            "Phone": phno   
        }

        axios.post(`${Baseurl.baseurl}/staff/add-staff`,artical)
            .then((response)=>{
                if(response.data.status){
                    swal("Staff Added",response.data.message, "success",{ button: "Done",timer: 1000})
                    setName('')
                    setemail('')
                    setpassword('')
                    setrole('')
                    setphon('')
                    history.push('/all-staff')
                }
                else
                {
                    swal("Oops",response.data.message, "error",{ button: "Done",timer: 1000})
                }
                }
        )
        .catch((err) => {
            if(err.toString()==="Error: Network Error")
            {
              history.push('/offline')
            }
            else
            {
              history.push('/400')
            }
        })
    }
    return (
        <div className="row">
            <div className="col-xl-12 col-lg-12">
                <div className="card" style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}>
                    <div className="card-header">
                        <h4 className="card-title text-white">Add Staff</h4>
                        <button
            className="btn btn-primary"
            onClick={() => {
              history.push('/all-staff');
            }}
          >
            Back
          </button>
                    </div>
                    <div className="card-body">
                        <div className="basic-form">
                            <form onSubmit={(e) => submitHandler(e)}>
                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label">Name</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="name"
                                            onChange={(e) => setName(e.target.value)}
                                            required />
                                    </div>
                                    <label className="col-sm-2 col-form-label">Phone no.</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="phone"
                                            className="form-control"
                                            placeholder="Phone no."
                                            onChange={(e) => setphon(e.target.value)}
                                            required
                                            maxLength={10}
                                            />

                                    </div>
                                </div>
                            
                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label">Email</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="email"
                                            className="form-control"
                                            placeholder="Email"
                                            onChange={(e) => setemail(e.target.value)}
                                            required />
                                    </div>
                                    <label className="col-sm-2 col-form-label">Password</label>
                                    <div className="col-sm-4">
                                        <input
                                            type="password"
                                            className="form-control"
                                            placeholder="Password"
                                            minLength={6}
                                            onChange={(e) => setpassword(e.target.value)}
                                            required />
                                    </div>
                                </div>
                                <div className="form-group row">
                                    <label className="col-sm-2 col-form-label">Select Role</label>
                                   <div className="col-sm-4">
                                   <select
                                        className="form-control"
                                        id="sel1"
                                        onChange={(e) => setrole(e.target.value)}
                                        required >
                                        <option value="">--Select--</option>
                                        {getData.map((d, i) => (
                                            <option value={d.Title}>{d.Title}</option>
                                        ))}
                                    </select>
                                   </div>
                                   <div className='col-sm-2'>
                                   <input
                                    className="btn btn-primary"
                                    type="submit"
                                    value="submit"
                                />
                                   </div>
                                </div>  
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AddNewStaff
